import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormMultipleInputFile from "Common/Custom/FormMultipleInputFile";

// Uses `fields` prop from parent — does not re-import JSON directly
const AddHallImagesForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleFileChange,
    handleSubmit,
    loading,
    roomList = [],
    imagePreview,
}) => {
    return (
        <PageBody
            headerchildren={<HeadingOne>Add Hall Images</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "file") {
                    return (
                        <FormMultipleInputFile
                            key={field.name}
                            field={field}
                            handleChange={handleFileChange}
                            error={errors.hall_image}
                            imagePreview={imagePreview}
                        />
                    );
                }
                if (field.type === "select") {
                    const options = roomList.map((opt) => ({
                        value: opt.id,
                        label: opt.hallroom_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Add Hall Image"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddHallImagesForm;
